import { render, staticRenderFns } from "./nothing.vue?vue&type=template&id=2e619286&scoped=true"
import script from "./nothing.vue?vue&type=script&lang=js"
export * from "./nothing.vue?vue&type=script&lang=js"
import style0 from "./nothing.vue?vue&type=style&index=0&id=2e619286&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e619286",
  null
  
)

export default component.exports